/**
 * Surcharge types a supplier can create.
 */
export const SURCHARGE_TYPES = [
    { value: "blackouts", label: "Blackouts Dates" },
    { value: "special_event", label: "Special Event" },
    { value: "weekend_dates", label: "Weekend Fees" },
    { value: "night_fees", label: "Night Fees" },
    { value: "seasonal", label: "Seasonal Fees" }
]

/**
 * Days a weekend fee can apply on, named as the keys of `custom.repeat_on`.
 */
export const WEEKEND_DAY_OPTIONS = [
    { value: "friday", label: "Friday" },
    { value: "saturday", label: "Saturday" },
    { value: "sunday", label: "Sunday" }
]
